/**
 * Voluum GET /tag (proxied) — lander tag suggestions.
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';

function unwrap<T>(data: unknown): T {
  if (data !== null && typeof data === 'object' && 'data' in data) {
    return (data as { data: T }).data;
  }
  return data as T;
}

function normalizeTags(raw: unknown): string[] {
  const body = unwrap(raw) as { tags?: unknown };
  const tags = body?.tags;
  if (!Array.isArray(tags)) return [];
  const strings = tags.filter((t): t is string => typeof t === 'string');
  return [...new Set(strings.map((t) => t.trim()).filter(Boolean))];
}

export async function getVoluumLanderTags(tagPrefix?: string): Promise<string[]> {
  const { data } = await api.get<unknown>('/voluum/tag', {
    params: {
      entityType: 'LANDER',
      ...(tagPrefix ? { tagPrefix } : {}),
    },
  });
  return normalizeTags(data);
}
